module.exports = {"data":{"site":{"siteMetadata":{"title":"US Trip","description":"Zážitky z cest po USA. Píše Martin, Luděk a Vojta."}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 129
// module chunks = 60335399758886 114276838955818